var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAaDinnersclub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.117 25.7332H24.5785C29.9817 25.7332 34.2874 21.4465 34.4563 16.1512V16.0672C34.3718 10.6878 29.9817 6.31704 24.5785 6.40109H20.6949C15.5449 6.5692 11.4925 10.9399 11.6613 16.1512C11.6613 21.3625 15.8826 25.6492 21.117 25.7332ZM13.3499 16.0671C13.3499 11.6964 16.9802 8.08211 21.3703 8.08211C25.7604 8.08211 29.3907 11.6964 29.3907 16.0671C29.3907 20.4379 25.7604 24.0521 21.3703 24.0521C16.9802 24.0521 13.3499 20.4379 13.3499 16.0671ZM22.6367 21.4465V10.7718C25.5916 11.5283 27.4489 14.4701 26.6891 17.412C26.1826 19.4292 24.6629 20.9422 22.6367 21.4465ZM16.1359 14.7223C15.3761 17.6641 17.149 20.69 20.1039 21.4465V10.7718C18.1621 11.2761 16.6425 12.7891 16.1359 14.7223Z",
    fill: "#0079BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAaDinnersclub);
export default __webpack_public_path__ + "static/media/aa-dinnersclub.0a9043cafe4678688cf2d581ecdb0724.svg";
export { ForwardRef as ReactComponent };